import ApiResponse from "../models/apiResponse";
import apiClient from "./client";
import Util from "./util";
import WorkspaceProperties from "../models/workspaceProperties";
import QueryContext from "../models/queryContext";

export default {
  async all(params: any): Promise<ApiResponse> {
    const url = "/api/v1/workspaces";

    return await apiClient.get(url, {
      headers: Util.authHeaders(),
      params: params,
    });
  },
  async allPosts(slug: string, params: QueryContext): Promise<ApiResponse> {
    const url = `/api/v1/workspaces/${slug}/posts`;

    return await apiClient.get(url, {
      headers: Util.authHeaders(),
      params: params,
    });
  },
  async allRoutines(slug: string, params: QueryContext): Promise<ApiResponse> {
    const url = `/api/v1/workspaces/${slug}/routines`;

    return await apiClient.get(url, {
      headers: Util.authHeaders(),
      params: params,
    });
  },
  async allUsers(slug: string, params: QueryContext): Promise<ApiResponse> {
    const url = `/api/v1/workspaces/${slug}/users`;

    return await apiClient.get(url, {
      headers: Util.authHeaders(),
      params: params,
    });
  },
  async getBySlug(slug: string): Promise<ApiResponse> {
    const url = `/api/v1/workspaces/${slug}`;
    return await apiClient.get(url, { headers: Util.authHeaders() });
  },
  async update(
    slug: string,
    properties: WorkspaceProperties,
  ): Promise<ApiResponse> {
    const url = `/api/v1/workspaces/${slug}`;
    return await apiClient.put(url, properties, {
      headers: Util.authHeaders(),
    });
  },
  async updateAvatar(slug: string, file: File): Promise<ApiResponse> {
    const url = `/api/v1/workspaces/${slug}/avatar`;
    const params = new FormData();
    params.append("avatar", file);
    return await apiClient.put(url, params, { headers: Util.authHeaders() });
  },
};
